import * as types from './types';

export const changeUsersVersion = () => ({
  type: types.CHANGE_USERS_VERSION
});
